import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import "./styles.css";
import PublicBookingApp from "./src/PublicBookingApp";
import { publicBookingStore } from "./src/store";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Provider store={publicBookingStore}>
      <PublicBookingApp />
    </Provider>
  </StrictMode>,
);
